import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../core/api';

@Injectable({
  providedIn: 'root'
})
export class ChargersService {
  private readonly apiService = inject(ApiService);

  securityProfileResetMinimumRequired(chargingBoxId: number): Observable<void> {
    return this.apiService.patch(`chargers/security-profile/${chargingBoxId}/reset-minimum-required`, {});
  }
}
